var $389a15bb9b199370$exports = {};
class $389a15bb9b199370$var$HtmlTemplate extends HTMLElement {
    constructor(){
        super();
        this.attachShadow({
            mode: 'open'
        });
    }
    static get observedAttributes() {
        return [
            'contents'
        ];
    }
    attributeChangedCallback(name, _, newValue) {
        if (name == 'contents') this.shadowRoot.innerHTML = newValue;
    }
}
window.customElements.define('html-template', $389a15bb9b199370$var$HtmlTemplate);


//# sourceMappingURL=project.ebb61f18.js.map
